export const ITEM_SIDE_BAR = 'ITEM_SIDE_BAR';
export const GET_GAPREPORT_INV='GET_GAPREPORT_INV';
export const ADD_DYNAMIC_TE003_DATA='ADD_DYNAMIC_TE003_DATA';
export const UPDATE_TE003_FORM='UPDATE_TE003_FORM';
export const GAPREPORT_DETLS_LOADER='GAPREPORT_DETLS_LOADER';
export const DELETE_GAP_COMPONENT='DELETE_GAP_COMPONENT';
export const ERROR_MESSAGE_03= 'ERROR_MESSAGE_03';
export const CLEAR_ERR_MESSGAE_03= 'CLEAR_ERR_MESSGAE_03';